export default {"src":"/_next/static/media/PPSI.206aba42.svg","height":18,"width":18};